import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 1.1",
  "description": "Turborepo 1.1에서는 자동 마이그레이션, turbo.json 구성, 환경 변수 종속성, 부분적인 Yarn v2 지원 등이 도입되었습니다!",
  "date": "2022/01/31",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "12월 중순 Turborepo v1.0을 출시한 이후 놀라운 도입률을 보였습니다:"
  }, {
    "heading": "",
    "content": "5.5k+ GitHub Stars"
  }, {
    "heading": "",
    "content": "주간 npm 다운로드 70k+"
  }, {
    "heading": "",
    "content": "65+ OSS 기여자"
  }, {
    "heading": "",
    "content": "Vercel, AWS, PayPal, Twilio, Contentful, Miro, Framer, Discord.js, Rocket.chat, Astro.build에서 프로덕션 사용 중"
  }, {
    "heading": "",
    "content": "Turborepo Community Discord 회원 585명+"
  }, {
    "heading": "",
    "content": "Turborepo v1.1에서는 빌드 성능과 캐싱을 더욱 개선하고 다음 기능을 제공합니다:"
  }, {
    "heading": "",
    "content": "자동 마이그레이션: 업그레이드를 지원하는 공식 멱등성 마이그레이션 스크립트입니다."
  }, {
    "heading": "",
    "content": "turbo.json 지원: Turborepo 구성이 이제 자체 파일에 저장됩니다."
  }, {
    "heading": "",
    "content": "더 빠른 패키지 매니저 감지: Turborepo가 이제 루트 package.json의 packageManager 키를 준수합니다."
  }, {
    "heading": "",
    "content": "환경 변수 종속성: 환경 변수가 전역 및 작업별 캐싱에 미치는 영향을 정의합니다."
  }, {
    "heading": "",
    "content": "Yarn v2+ 부분 지원: nodeLinker: \"node-modules\"를 사용하는 yarn v2+ 지원입니다."
  }, {
    "heading": "",
    "content": "npm install turbo@latest를 실행하여 오늘 업데이트하세요. turbo를 실행한 후 @turbo/codemod를 사용하여 v1.1에 대한 자동 마이그레이션을 실행하는 방법에 대한 지침이 표시됩니다."
  }, {
    "heading": "자동-마이그레이션",
    "content": "Turborepo는 이제 기능이 더 이상 사용되지 않거나 향후 사용 중단될 때 Turborepo 코드베이스를 업그레이드하는 데 도움이 되는 멱등성 코드 변환 및 자동 마이그레이션 스크립트(일명 \"codemod\")를 제공합니다."
  }, {
    "heading": "자동-마이그레이션",
    "content": "Codemod는 프로그래밍 방식으로 코드베이스에서 실행되는 변환입니다. 이를 통해 모든 파일을 수동으로 검토하고 편집하지 않고도 코드에 대량의 변경 사항을 자동으로 적용하여 시간을 절약할 수 있습니다."
  }, {
    "heading": "사용법",
    "content": "transform - 변환 이름입니다. 문서에서 사용 가능한 변환 확인."
  }, {
    "heading": "사용법",
    "content": "path - 변환할 파일 또는 디렉터리입니다."
  }, {
    "heading": "사용법",
    "content": "--dry - 드라이 런을 수행하며 코드가 편집되지 않습니다."
  }, {
    "heading": "사용법",
    "content": "--print - 비교를 위해 변경된 출력을 인쇄합니다."
  }, {
    "heading": "사용법",
    "content": "특정 변환에 대한 자세한 내용은 새로운 Codemod 문서를 확인하세요."
  }, {
    "heading": "turbojson-지원",
    "content": "Turborepo 구성이 이제 모노레포 루트의 turbo.json 파일에 정의됩니다. 이는 코드 편집기에서 Turborepo 구성으로 빠르게 이동하려는 사용자를 위해 package.json에 turbo 키를 포함하는 것보다 개선된 방식입니다."
  }, {
    "heading": "turbojson-지원",
    "content": "package.json의 현재 구성에서 자동으로 마이그레이션하려면 새 브랜치를 체크아웃하고 모노레포 루트로 이동한 다음 다음 codemod를 실행하세요:"
  }, {
    "heading": "turbojson-지원",
    "content": "이 변환에 대한 자세한 내용은 문서를 확인하세요."
  }, {
    "heading": "더-빠른-패키지-매니저-감지",
    "content": "Turborepo는 이제 더 빠른 패키지 매니저 감지를 위해 최근 설정된 package.json의 packageManager 필드를 지원합니다. 이전에는 turbo가 특정 파일을 확인하여 이 정보를 추론했습니다. 이 필드를 자동으로 설정하려면 새 브랜치를 체크아웃하고 모노레포 루트로 이동한 다음 다음을 실행하세요:"
  }, {
    "heading": "더-빠른-패키지-매니저-감지",
    "content": "이 변환에 대한 자세한 내용은 문서를 확인하세요."
  }, {
    "heading": "환경-변수-종속성",
    "content": "빌드 시 환경 변수를 인라인하는 도구(예: Next.js 또는 Create React App)와 함께 turbo를 사용하는 경우, 잘못된 환경 변수로 캐시된 아티팩트를 배포하지 않도록 turbo에 이를 알리는 것이 중요합니다."
  }, {
    "heading": "환경-변수-종속성",
    "content": "이제 환경 변수 값과 파일 내용을 기반으로 turbo의 캐시 지문(일명 해싱) 동작을 제어할 수 있습니다:"
  }, {
    "heading": "환경-변수-종속성",
    "content": "$ 접두사가 붙은 pipeline 정의의 dependsOn에 환경 변수를 포함하면 작업별 또는 패키지-작업별로 캐시 지문에 영향을 줍니다."
  }, {
    "heading": "환경-변수-종속성",
    "content": "$ 접두사가 붙은 globalDependencies 목록에 환경 변수를 포함하면 모든 작업의 캐시 지문에 영향을 줍니다."
  }, {
    "heading": "환경-변수-종속성",
    "content": "globalDependencies에 파일 또는 파일 glob을 포함하면 모든 작업의 캐시 지문에 영향을 줍니다."
  }, {
    "heading": "환경-변수-종속성",
    "content": "참고: 대부분의 모노레포에서는 공유 패키지에서 환경 변수를 자주 사용하지 않고 주로 애플리케이션에서 사용합니다. 따라서 더 높은 캐시 적중률을 얻으려면 환경 변수가 사용/인라인되는 앱별 작업에만 환경 변수를 포함해야 합니다."
  }, {
    "heading": "환경-변수-종속성",
    "content": "자세한 내용은 캐싱 및 해싱 문서를 읽어보세요."
  }, {
    "heading": "yarn-v2v3-부분-지원",
    "content": "Yarn v1, npm 및 pnpm 패키지 매니저 외에도 Turborepo는 이제 .yarnrc.yml에 nodeLinker: \"node-modules\" 설정을 사용하는 Yarn v2+를 지원합니다. 이 키는 Yarn v2+에게 Yarn v1의 node_modules 설치 동작을 모방하도록 지시합니다. Yarn v2+ Plug'n'Play(일명 \"PnP\")는 현재 지원되지 않습니다."
  }, {
    "heading": "다음은-무엇입니까",
    "content": "출시 이후 Turborepo는 원활한 점진적 도입/마이그레이션과 CI/CD 속도 향상에 중점을 두었습니다. 우리는 이 두 가지 가치에 계속 전념하지만 이제는 로컬 개발 및 관찰 가능성을 위한 Turborepo의 일상적인 인체공학 개선에도 중점을 둘 것입니다. 우리는 이 다음 장에 대해 정말 기대하고 있으며 곧 더 많은 세부 정보를 공유할 것입니다."
  }, {
    "heading": "인재-채용-중",
    "content": "Vercel의 Turborepo 팀이 채용 중입니다! Turborepo를 더욱 개선하는 데 도움을 줄 풀타임 Senior Full Stack Software Engineers 및 Senior DevOps/Infrastructure Engineers를 구체적으로 찾고 있습니다."
  }],
  "headings": [{
    "id": "자동-마이그레이션",
    "content": "자동 마이그레이션"
  }, {
    "id": "사용법",
    "content": "사용법"
  }, {
    "id": "turbojson-지원",
    "content": "turbo.json 지원"
  }, {
    "id": "더-빠른-패키지-매니저-감지",
    "content": "더 빠른 패키지 매니저 감지"
  }, {
    "id": "환경-변수-종속성",
    "content": "환경 변수 종속성"
  }, {
    "id": "yarn-v2v3-부분-지원",
    "content": "Yarn v2/v3 부분 지원"
  }, {
    "id": "다음은-무엇입니까",
    "content": "다음은 무엇입니까?"
  }, {
    "id": "인재-채용-중",
    "content": "인재 채용 중!"
  }]
};
import __img0 from "./../../public/images/blog/turbo-1-1-0/turborepo-weekly-npm-downloads.png";
import {Authors} from '#components/authors';
export const toc = [{
  depth: 2,
  url: "#자동-마이그레이션",
  title: _jsx(_Fragment, {
    children: "자동 마이그레이션"
  })
}, {
  depth: 3,
  url: "#사용법",
  title: _jsx(_Fragment, {
    children: "사용법"
  })
}, {
  depth: 2,
  url: "#turbojson-지원",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "turbo.json"
    }), " 지원"]
  })
}, {
  depth: 2,
  url: "#더-빠른-패키지-매니저-감지",
  title: _jsx(_Fragment, {
    children: "더 빠른 패키지 매니저 감지"
  })
}, {
  depth: 2,
  url: "#환경-변수-종속성",
  title: _jsx(_Fragment, {
    children: "환경 변수 종속성"
  })
}, {
  depth: 2,
  url: "#yarn-v2v3-부분-지원",
  title: _jsx(_Fragment, {
    children: "Yarn v2/v3 부분 지원"
  })
}, {
  depth: 2,
  url: "#다음은-무엇입니까",
  title: _jsx(_Fragment, {
    children: "다음은 무엇입니까?"
  })
}, {
  depth: 2,
  url: "#인재-채용-중",
  title: _jsx(_Fragment, {
    children: "인재 채용 중!"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    img: "img",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 1.1"
    }), "\n", "\n", _jsx(Authors, {
      authors: ['jaredpalmer', 'becca__z', 'gaspargarcia', 'gregsoltis']
    }), "\n", _jsx(_components.p, {
      children: "12월 중순 Turborepo v1.0을 출시한 이후 놀라운 도입률을 보였습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "5.5k+ GitHub Stars"
      }), "\n", _jsx(_components.li, {
        children: "주간 npm 다운로드 70k+"
      }), "\n", _jsx(_components.li, {
        children: "65+ OSS 기여자"
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://github.com/vercel/next.js",
          children: "Vercel"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/aws-amplify/amplify-ui",
          children: "AWS"
        }), ", ", _jsx(_components.a, {
          href: "https://x.com/jaredpalmer/status/1485617973477978121",
          children: "PayPal"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/twilio-labs/function-templates",
          children: "Twilio"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/contentful/forma-36",
          children: "Contentful"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/miroapp/app-examples",
          children: "Miro"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/framer/motion",
          children: "Framer"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/discordjs/discord.js",
          children: "Discord.js"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/RocketChat/fuselage",
          children: "Rocket.chat"
        }), ", ", _jsx(_components.a, {
          href: "https://github.com/withastro/astro",
          children: "Astro.build"
        }), "에서 프로덕션 사용 중"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "https://turborepo.com/discord",
          children: "Turborepo Community Discord"
        }), " 회원 585명+"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "Weekly npm downloads of turbo",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsx(_components.p, {
      children: "Turborepo v1.1에서는 빌드 성능과 캐싱을 더욱 개선하고 다음 기능을 제공합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#automatic-migrations",
          children: _jsx(_components.strong, {
            children: "자동 마이그레이션:"
          })
        }), " 업그레이드를 지원하는 공식 멱등성 마이그레이션 스크립트입니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#turbojson-support",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "turbo.json"
            }), " 지원:"]
          })
        }), " Turborepo 구성이 이제 자체 파일에 저장됩니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#faster-package-manager-detection",
          children: _jsx(_components.strong, {
            children: "더 빠른 패키지 매니저 감지:"
          })
        }), " Turborepo가 이제 루트 ", _jsx(_components.code, {
          children: "package.json"
        }), "의 ", _jsx(_components.code, {
          children: "packageManager"
        }), " 키를 준수합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#environment-variable-dependencies",
          children: _jsx(_components.strong, {
            children: "환경 변수 종속성:"
          })
        }), " 환경 변수가 전역 및 작업별 캐싱에 미치는 영향을 정의합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#partial-yarn-v2v3-support",
          children: _jsx(_components.strong, {
            children: "Yarn v2+ 부분 지원:"
          })
        }), " ", _jsx(_components.code, {
          children: "nodeLinker: \"node-modules\""
        }), "를 사용하는 yarn v2+ 지원입니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npm install turbo@latest"
      }), "를 실행하여 오늘 업데이트하세요. ", _jsx(_components.code, {
        children: "turbo"
      }), "를 실행한 후 ", _jsx(_components.code, {
        children: "@turbo/codemod"
      }), "를 사용하여 ", _jsx(_components.code, {
        children: "v1.1"
      }), "에 대한 자동 마이그레이션을 실행하는 방법에 대한 지침이 표시됩니다."]
    }), "\n", _jsx(_components.h2, {
      id: "자동-마이그레이션",
      children: "자동 마이그레이션"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 이제 기능이 더 이상 사용되지 않거나 향후 사용 중단될 때 Turborepo 코드베이스를 업그레이드하는 데 도움이 되는 멱등성 코드 변환 및 자동 마이그레이션 스크립트(일명 \"codemod\")를 제공합니다."
    }), "\n", _jsx(_components.p, {
      children: "Codemod는 프로그래밍 방식으로 코드베이스에서 실행되는 변환입니다. 이를 통해 모든 파일을 수동으로 검토하고 편집하지 않고도 코드에 대량의 변경 사항을 자동으로 적용하여 시간을 절약할 수 있습니다."
    }), "\n", _jsx(_components.h3, {
      id: "사용법",
      children: "사용법"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " <"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "transfor"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "m"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ">"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " <"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "pat"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "h"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ">"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "transform"
        }), " - 변환 이름입니다. ", _jsx(_components.a, {
          href: "/docs/reference/turbo-codemod#turborepo-1x",
          children: "문서에서 사용 가능한 변환 확인"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "path"
        }), " - 변환할 파일 또는 디렉터리입니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--dry"
        }), " - 드라이 런을 수행하며 코드가 편집되지 않습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--print"
        }), " - 비교를 위해 변경된 출력을 인쇄합니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["특정 변환에 대한 자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#turborepo-1x",
        children: "새로운 Codemod 문서"
      }), "를 확인하세요."]
    }), "\n", _jsxs(_components.h2, {
      id: "turbojson-지원",
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), " 지원"]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 구성이 이제 모노레포 루트의 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 파일에 정의됩니다. 이는 코드 편집기에서 Turborepo 구성으로 빠르게 이동하려는 사용자를 위해 ", _jsx(_components.code, {
        children: "package.json"
      }), "에 ", _jsx(_components.code, {
        children: "turbo"
      }), " 키를 포함하는 것보다 개선된 방식입니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "package.json"
      }), "의 현재 구성에서 자동으로 마이그레이션하려면 새 브랜치를 체크아웃하고 모노레포 루트로 이동한 다음 다음 codemod를 실행하세요:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " create-turbo-config"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ."
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 변환에 대한 자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#create-turbo-config",
        children: "문서를 확인"
      }), "하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "더-빠른-패키지-매니저-감지",
      children: "더 빠른 패키지 매니저 감지"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 이제 더 빠른 패키지 매니저 감지를 위해 최근 설정된 ", _jsx(_components.code, {
        children: "package.json"
      }), "의 ", _jsx(_components.code, {
        children: "packageManager"
      }), " 필드를 지원합니다. 이전에는 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 특정 파일을 확인하여 이 정보를 추론했습니다. 이 필드를 자동으로 설정하려면 새 브랜치를 체크아웃하고 모노레포 루트로 이동한 다음 다음을 실행하세요:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " @turbo/codemod"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " add-package-manager"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " ."
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 변환에 대한 자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/turbo-codemod#add-package-manager",
        children: "문서를 확인"
      }), "하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "환경-변수-종속성",
      children: "환경 변수 종속성"
    }), "\n", _jsxs(_components.p, {
      children: ["빌드 시 환경 변수를 인라인하는 도구(예: Next.js 또는 Create React App)와 함께 ", _jsx(_components.code, {
        children: "turbo"
      }), "를 사용하는 경우, 잘못된 환경 변수로 캐시된 아티팩트를 배포하지 않도록 ", _jsx(_components.code, {
        children: "turbo"
      }), "에 이를 알리는 것이 중요합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이제 환경 변수 값과 파일 내용을 기반으로 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching#task-inputs",
        children: "캐시 지문(일명 해싱)"
      }), " 동작을 제어할 수 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "$"
        }), " 접두사가 붙은 ", _jsx(_components.code, {
          children: "pipeline"
        }), " 정의의 ", _jsx(_components.code, {
          children: "dependsOn"
        }), "에 환경 변수를 포함하면 작업별 또는 패키지-작업별로 캐시 지문에 영향을 줍니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "$"
        }), " 접두사가 붙은 ", _jsx(_components.code, {
          children: "globalDependencies"
        }), " 목록에 환경 변수를 포함하면 ", _jsx(_components.em, {
          children: "모든"
        }), " 작업의 캐시 지문에 영향을 줍니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "globalDependencies"
        }), "에 파일 또는 파일 glob을 포함하면 ", _jsx(_components.em, {
          children: "모든"
        }), " 작업의 캐시 지문에 영향을 줍니다."]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"pipeline\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"^build\""
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "        // env vars will impact hashes of all \"build\" tasks"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "        \"$SOME_ENV_VAR\""
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"dist/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"web#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// override settings for the \"build\" task for the \"web\" app"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "          // env vars that will impact the hash of \"build\" task for only \"web\" app"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$STRIPE_SECRET_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$NEXT_PUBLIC_STRIPE_PUBLIC_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$NEXT_PUBLIC_ANALYTICS_ID\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"docs#build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// override settings for the \"build\" task for the \"docs\" app"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "        \"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "          // env vars that will impact the hash of \"build\" task for only \"web\" app"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$STRIPE_SECRET_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$NEXT_PUBLIC_STRIPE_PUBLIC_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "          \"$NEXT_PUBLIC_ANALYTICS_ID\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"outputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".next/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"!.next/cache/**\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "    \"$GITHUB_TOKEN\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// env var that will impact the hashes of all tasks,"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "    \"tsconfig.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // file contents will impact the hashes of all tasks,"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "    \".env.*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // glob file contents will impact the hashes of all tasks,"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ]"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "참고: 대부분의 모노레포에서는 공유 패키지에서 환경 변수를 자주 사용하지 않고 주로 애플리케이션에서 사용합니다. 따라서 더 높은 캐시 적중률을 얻으려면 환경 변수가 사용/인라인되는 앱별 작업에만 환경 변수를 포함해야 합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching#task-inputs",
        children: "캐싱 및 해싱 문서"
      }), "를 읽어보세요."]
    }), "\n", _jsx(_components.h2, {
      id: "yarn-v2v3-부분-지원",
      children: "Yarn v2/v3 부분 지원"
    }), "\n", _jsxs(_components.p, {
      children: ["Yarn v1, npm 및 pnpm 패키지 매니저 외에도 Turborepo는 이제 ", _jsxs(_components.a, {
        href: "https://yarnpkg.com/configuration/yarnrc#nodeLinker",
        children: [_jsx(_components.code, {
          children: ".yarnrc.yml"
        }), "에 ", _jsx(_components.code, {
          children: "nodeLinker: \"node-modules\""
        }), " 설정"]
      }), "을 사용하는 Yarn v2+를 지원합니다. 이 키는 Yarn v2+에게 Yarn v1의 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 설치 동작을 모방하도록 지시합니다. Yarn v2+ Plug'n'Play(일명 \"PnP\")는 현재 지원되지 않습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "다음은-무엇입니까",
      children: "다음은 무엇입니까?"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/joining-vercel",
        children: "출시 이후"
      }), " Turborepo는 원활한 점진적 도입/마이그레이션과 CI/CD 속도 향상에 중점을 두었습니다. 우리는 이 두 가지 가치에 계속 전념하지만 이제는 로컬 개발 및 관찰 가능성을 위한 Turborepo의 일상적인 인체공학 개선에도 중점을 둘 것입니다. 우리는 이 다음 장에 대해 정말 기대하고 있으며 곧 더 많은 세부 정보를 공유할 것입니다."]
    }), "\n", _jsx(_components.h2, {
      id: "인재-채용-중",
      children: "인재 채용 중!"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com/",
        children: "Vercel"
      }), "의 Turborepo 팀이 채용 중입니다! Turborepo를 더욱 개선하는 데 도움을 줄 풀타임 ", _jsx(_components.a, {
        href: "https://vercel.com/careers",
        children: "Senior Full Stack Software Engineers"
      }), " 및 ", _jsx(_components.a, {
        href: "https://vercel.com/careers",
        children: "Senior DevOps/Infrastructure Engineers"
      }), "를 구체적으로 찾고 있습니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
